/* eslint-disable @next/next/no-html-link-for-pages */
import { Layout } from "components/global/layouts";
import type { NextPage } from "next";
import { useRouter } from "next/router";

const Home: NextPage | any = () => {
  const router = useRouter();

  router.push("/entities/product");
  return (
    <Layout title="DashBoard">
      <></>
      {/* <Flex direction={"row"} gap={40}>
        <a
          href="/entities/page/home"
          style={{ color: "black", textDecoration: "none" }}
        >
          <Flex direction={"column"} justify={"center"} align={"center"}>
            <Avatar variant="filled" radius="lg" size="lg">
              {" "}
              <IconHome />{" "}
            </Avatar>
            Home
          </Flex>
        </a>
        <a
          href="/entities/page/academia"
          style={{ color: "black", textDecoration: "none" }}
        >
          <Flex direction={"column"} justify={"center"} align={"center"}>
            <Avatar variant="filled" radius="lg" size="lg">
              {" "}
              <IconSchool />{" "}
            </Avatar>
            Academia
          </Flex>
        </a>
        <a
          href="/entities/page/trabalhe-conosco"
          style={{ color: "black", textDecoration: "none" }}
        >
          <Flex direction={"column"} justify={"center"} align={"center"}>
            <Avatar variant="filled" radius="lg" size="lg">
              {" "}
              <IconBrandOffice />{" "}
            </Avatar>
            Trabalhe <br /> Conosco
          </Flex>
        </a>
      </Flex>

      <Divider mt={10} /> */}
    </Layout>
  );
};

Home.auth = true;
Home.roles = ["superadmin", "admin", "user"];

export default Home;
